/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import { CareersViewRendererProps } from '../../types';
import { OpenPositions } from '../../components';

function Desktop(props: CareersViewRendererProps) {
  const { careers, orgId, loading } = props;
  return (
    <OpenPositions careers={careers} orgId={orgId} loading={loading} />
  );
}

export default Desktop;
